module.exports = __webpack_public_path__ + "img/AC_S5_Header.db9f76e1.jpg";